import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FocusDivDirective } from './focus-div.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [FocusDivDirective],
  exports: [FocusDivDirective]
})
export class SharedModule {}
